import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import AdminLogin from "@/pages/AdminLogin";
import CostSegregation from "@/pages/CostSegregation";
import RDTaxCredit from "@/pages/RDTaxCredit";
import ForCPAs from "@/pages/ForCPAs";
import About from "@/pages/About";
import CostSegCalculatorPage from "@/pages/CostSegCalculatorPage";
import RDCalculatorPage from "@/pages/RDCalculatorPage";
import Knowledge from "@/pages/Knowledge";
import KnowledgeArticle from "@/pages/KnowledgeArticle";
import ScrollManager from "@/components/site/ScrollManager";

function App() {
  return (
    <div className="App min-h-screen bg-ivory text-charcoal">
      <BrowserRouter>
        <AuthProvider>
          <ScrollManager />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services/cost-segregation" element={<CostSegregation />} />
            <Route path="/services/rd-tax-credit" element={<RDTaxCredit />} />
            <Route path="/for-tax-professionals" element={<ForCPAs />} />
            <Route path="/about" element={<About />} />
            <Route path="/calculators/cost-segregation" element={<CostSegCalculatorPage />} />
            <Route path="/calculators/rd-tax-credit" element={<RDCalculatorPage />} />
            <Route path="/knowledge" element={<Knowledge />} />
            <Route path="/knowledge/:slug" element={<KnowledgeArticle />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <Toaster position="bottom-right" theme="light" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
